import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BlockContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  max-width: 100%;
  padding: 16px;
  border: 1px solid ${(props) => props.theme.colors.inactive};
  border-radius: 10px;

  .theme-description {
    display: flex;
    flex-direction: column;
    gap: 6px;

    p {
      color: ${(props) => props.theme.colors.inactive};
      font-size: 13px;
    }
  }

  .theme-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 128px;
    height: 40px;
    padding: 8px 16px;
    border: 1px solid ${(props) => props.theme.colors.outline};
    border-radius: 8px;
    background: ${(props) => props.theme.colors.widget_background};
    color: ${(props) => props.theme.colors.text};
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s;

    &:hover {
      border-color: ${(props) => props.theme.colors.main_cta};
      background: ${(props) => props.theme.colors.widget_hover_background};
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.colors.main_cta};
      outline-offset: 2px;
    }
  }
`;

export default { Wrapper, BlockContainer };
